import React, { useEffect, useState, Suspense } from 'react';
import { BrowserRouter, useLocation, useNavigate } from 'react-router-dom';
import phone from './assets/images/ic_newupdate.png';
//import { Elements } from '@stripe/react-stripe-js';
//import {loadStripe} from '@stripe/stripe-js';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/App.css';
// import "./styles/AppResponsive.css";
import './styles/AppRtl.css';

import Routes from './components/routing/Routes';
import CountryGate from './components/routing/CountryGate';
import CustomModal from './components/shop/Modal';
import { useTranslation } from 'react-i18next';
import {
  ApplicationLanguageProvider,
  ApplicationParamsProvider,
  UserProfileProvider,
  useApplicationParams,
} from './context';

// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const ApplicationInitialization = () => {
  const [isUseInsiderScriptReady, setIsUseInsiderScriptReady] = useState(false);
  const [newUpdateModalOpen, setNewUpdateModalOpen] = useState({
    openedOnce: false,
    opened: false,
  });

  const { t } = useTranslation();

  const { isWeb, isAndroid, isIos, appVersion, platform } = useApplicationParams();

  useEffect(() => {
    if (isWeb) {
      document.body.classList.add('lg');
    }
  }, [isWeb]);

  useEffect(() => {
    if (((isIos && appVersion) || isWeb || isAndroid) && !isUseInsiderScriptReady) {
      // injects useInsider iframe (3rd party iframes are allowed for new app versions (IOS))
      const script = document.createElement('script');
      script.src = '//360vuz.api.useinsider.com/ins.js?id=10004229';
      script.async = true;
      document.body.appendChild(script);

      setIsUseInsiderScriptReady(true);
    }

    if (platform === 'ios' && !appVersion && !newUpdateModalOpen.openedOnce) {
      setNewUpdateModalOpen({ openedOnce: true, opened: true });
    }

    if (isIos) {
      const meta = document.querySelector('meta[name="viewport"]');
      const content = meta.getAttribute('content');
      const newContent = content + ', maximum-scale=1, user-scalable=0';
      meta.setAttribute('content', newContent);
    }
  }, [
    appVersion,
    isAndroid,
    isIos,
    isWeb,
    newUpdateModalOpen.openedOnce,
    platform,
    isUseInsiderScriptReady,
  ]);

  return (
    <>
      {newUpdateModalOpen.opened ? (
        <CustomModal
          onClick={(e) => e.stopPropagation()}
          icon={<img alt="Phone" src={phone} width={112} height={129} />}
          description={
            <>
              <p className="new-update-header">{t('new_update_header')}</p>
              <p>{t('new_update_text')}</p>
            </>
          }
          show={newUpdateModalOpen.opened}
        />
      ) : null}
    </>
  );
};

const App = () => (
  <Suspense fallback={null}>
    <BrowserRouter basename="/">
      <ApplicationLanguageProvider>
        <ApplicationParamsProvider>
          <UserProfileProvider>
            <CountryGate>
              <Routes />
              <ApplicationInitialization />
            </CountryGate>
          </UserProfileProvider>
        </ApplicationParamsProvider>
      </ApplicationLanguageProvider>
    </BrowserRouter>
  </Suspense>
);

export default App;
